// Framed like the data grids (components/dataGrid.js): an outer border instead of a drop shadow.
export default function tableContainer({ colors, tokens }) {
  const { background } = colors;

  const tableContainer = {
    styleOverrides: {
      root: {
        backgroundColor: background.paper,
        border: `1px solid ${tokens["border-strong"]}`,
        borderRadius: "var(--radius)",
        boxShadow: "none",

        // The frame already closes the table, so the last row needs no rule of its own.
        "& .MuiTableBody-root:last-of-type > .MuiTableRow-root:last-of-type > .MuiTableCell-root": {
          borderBottom: 0,
        },
      },
    },
  };

  return tableContainer;
}
